// Lazy load function
const lazyLoad = (file) => () =>
    import(
    /* webpackChunkName: "[request]" */ `@/views/sales/distribution-manifest/${file}.vue`
    );

export default [
    {
        path: "/distribution-manifest",
        name: "distribution-manifest-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "DistributionManifest",
        },
        components: {
            content: lazyLoad('distribution-manifest-list'),
        },
    },
    {
        path: "/distribution-manifest/create",
        name: "distribution-manifest-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "DistributionManifest",
        },
        components: {
            content: lazyLoad('distribution-manifest'),
        },
    },
    {
        path: "/distribution-manifest/review/:id*",
        name: "distribution-manifest-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "DistributionManifest",
        },
        components: {
            content: lazyLoad('distribution-manifest'),
        },
    },
    {
        path: "/distribution-manifest/edit/:id*",
        name: "distribution-manifest-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "DistributionManifest",
        },
        components: {
            content: lazyLoad('distribution-manifest'),
        },
    },
];
